import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";

export const cancelIconRed = <CancelIcon color="error" />;

export const cancelIconRedSmall = <CancelIcon color="error" fontSize="small" />;
